import { useState, useEffect } from "react";

interface NotificationSoundSettings {
  enabled: boolean;
  volume: number;
}

const DEFAULT_SETTINGS: NotificationSoundSettings = {
  enabled: true,
  volume: 0.5,
};

const STORAGE_KEY = "notificationSoundSettings";

export const useNotificationSound = () => {
  const [settings, setSettings] = useState<NotificationSoundSettings>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : DEFAULT_SETTINGS;
    } catch {
      return DEFAULT_SETTINGS;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings: Partial<NotificationSoundSettings>) => {
    setSettings((prev) => ({ ...prev, ...newSettings }));
  };

  const playSound = () => {
    if (settings.enabled) {
      try {
        // Import and use the notification sound utility
        import("../utils/notificationSound").then(
          ({ playNotificationSound }) => {
            playNotificationSound();
          },
        );
      } catch (error) {
        console.warn("Failed to play notification sound:", error);
      }
    }
  };

  return {
    settings,
    updateSettings,
    playSound,
  };
};
